import React, { Component } from 'react';

class FileSaver extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      name: "projection",
      dropdownStyle: {
        position: 'absolute',
        zIndex: 9999,
        borderRadius: '8px',
        padding: '8px',
        borderWidth: '1px',
        borderColor: '#ccc',
        backgroundColor: '#eee'
      }
    }
  }

  changeName(e) {
    var name = e.target.value;
    this.setState({
      name
    });
  }

  setSaving(e) {
    this.setState({saving: !this.state.saving});
  }

  saveJSON(e) {
    var uri = "data:application/json;base64," + btoa(localStorage.getItem("projectorState"));
    var link = document.createElement("a");
    link.href = uri;
    link.download = this.state.name + ".json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.setState({saving: false});
  }

  render() {
    return (
      <div>
        <div>
          <button className='btn btn-info' onClick={(e) => this.setSaving(e)}>Download JSON</button>
        </div>
        <div hidden={!this.state.saving} style={this.state.dropdownStyle}>
          <input type="text" name="name" defaultValue={this.state.name} onChange={(e) => this.changeName(e)} />&nbsp;.json&nbsp;<br/>
          <button className='btn btn-info' onClick={(e) => this.saveJSON(e)}>Download</button>&nbsp;
          <button className='btn btn-danger' onClick={(e) => this.setSaving(e)}>Cancel</button>
        </div>
      </div>
    );
  }

}

export default FileSaver;



// WEBPACK FOOTER //
// ./src/FileSaver.js